import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, AttributionControl, useMap, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './mapIconFix';

const TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
/** Обязательная атрибуция OSM; префикс Leaflet (флаг + ссылка) отключаем через AttributionControl prefix={false}. */
const ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors';
const MOSCOW = [55.7558, 37.6173];

function MapRecenter({ lat, lng, zoom }) {
    const map = useMap();
    useEffect(() => {
        if (lat != null && lng != null)
            map.setView([lat, lng], zoom ?? (map.getZoom() || 16), { animate: true });
    }, [lat, lng, zoom, map]);
    return null;
}

function MapClickHandler({ onPick, enabled }) {
    useMapEvents({
        click(e) {
            if (enabled) onPick?.(e.latlng.lat, e.latlng.lng);
        }
    });
    return null;
}

export default function LocationMap({
    lat,
    lng,
    onCoordinatesChange,
    height = '200px',
    draggable = true,
    zoom = 16,
    alwaysShow = false,
    defaultCenter = MOSCOW,
    defaultZoom = 11,
    allowMapClick = false,
    hint = null
}) {
    const hasMarker = lat != null && lng != null;
    if (!hasMarker && !alwaysShow)
        return null;

    const center = hasMarker ? [Number(lat), Number(lng)] : defaultCenter;
    const mapZoom = hasMarker ? zoom : defaultZoom;

    return (
        <div style={{ marginTop: 8 }}>
            {hint && (
                <div style={{ fontSize: 12, color: '#64748b', marginBottom: 6 }}>{hint}</div>
            )}
            <div style={{
                height,
                borderRadius: 8,
                overflow: 'hidden',
                border: '1px solid var(--sp-gray-200)',
                position: 'relative',
                zIndex: 0
            }}>
                <MapContainer
                    center={center}
                    zoom={mapZoom}
                    style={{ height: '100%', width: '100%' }}
                    scrollWheelZoom
                    attributionControl={false}
                >
                    <TileLayer url={TILE_URL} attribution={ATTRIBUTION} maxZoom={19} />
                    <AttributionControl prefix={false} />
                    <MapRecenter lat={hasMarker ? lat : null} lng={hasMarker ? lng : null} zoom={mapZoom} />
                    <MapClickHandler
                        enabled={allowMapClick}
                        onPick={onCoordinatesChange}
                    />
                    {hasMarker && (
                        <Marker
                            position={[Number(lat), Number(lng)]}
                            draggable={draggable}
                            eventHandlers={{
                                dragend: (e) => {
                                    const { lat: newLat, lng: newLng } = e.target.getLatLng();
                                    onCoordinatesChange?.(newLat, newLng);
                                }
                            }}
                        />
                    )}
                </MapContainer>
            </div>
        </div>
    );
}
